<template>
  <div class="order_list">

    <mu-tabs :value.sync="order_json.status"
             class="tab"
             inverse
             full-width
             @change="tabChange"
             color="#3B9CFD"
             indicator-color="#3B9CFD"
             center>
      <mu-tab value="">全部</mu-tab>
      <mu-tab value="0">待付款</mu-tab>
<!--      <mu-tab value="1">待服务</mu-tab>-->
    </mu-tabs>

    <template v-if="list.length != 0">
      <ul class="list_ul">
        <mu-load-more :loaded-all="loadall" :loading="loading" @load="load">
          <li class="list_ul_li" v-for="item in list" :key="item.orderId" >
            <div class="list_name">
<!--              <p class="exa">{{ item.productCategory }}</p>-->
              <p class="exa" v-if="item.productCategory == 0">体检套餐</p>
              <p class="stomach" v-if="item.productCategory == 1">胃肠道筛查</p>
              <p class="stomach" v-if="item.productCategory == 2">整合式筛查</p>
              <p class="stomach" v-if="item.productCategory == 3">锦医未</p>
              <p :class="( item.status == 0 ? 'to-be-paid' : ( item.status == 4 ? 'to-be-del' : 'to-be-served' ) )" >{{ $store.state.orderState.filter( items => { return items.dictKey == item.status } )[0].dictValue }}</p>
            </div>
            <div class="list_li_deta" @click="link_orderDeta(item.orderId)">
              <img :src="item.thumbnail" alt="">
              <div class="list_item">
                <h2>{{ item.productName }}</h2>
                <p class="list_item_p1">{{ item.subhead }}</p>
                <p class="list_item_p2">{{ item.paymentAmount != 0 ? "¥" + item.paymentAmount : "卡支付" }}</p>
              </div>
            </div>
            <template>
              <ul class="list_ul_name">
                <li>
                  <span>就诊人</span>
                  <p>{{ item.name }}</p>
                </li>

<!--                <template v-if="item.productType == 1">-->
<!--                  <li class="list_ul_name_list" v-for="items in item.appointments" :key="items.id">-->
<!--                    <h2>{{ items.productCategory }}</h2>-->
<!--&lt;!&ndash;                    <h2 v-if="items.productCategory == 0">体检套餐</h2>&ndash;&gt;-->
<!--&lt;!&ndash;                    <h2 v-if="items.productCategory == 1">胃肠道筛查</h2>&ndash;&gt;-->
<!--&lt;!&ndash;                    <h2 v-if="items.productCategory == 2">整合式筛查</h2>&ndash;&gt;-->
<!--&lt;!&ndash;                    <h2 v-if="items.productCategory == 3">锦医未</h2>&ndash;&gt;-->
<!--                    <div class="time">-->
<!--                      <div class="list_ul_name_list_time">-->
<!--                        <span>预约时间</span>-->
<!--                        <p>{{ items.appointmentDate }} {{ items.appointmentTime }}</p>-->
<!--                      </div>-->
<!--                      <div class="list_ul_name_list_time">-->
<!--                        <span>预约地点</span>-->
<!--                        <p>{{ items.hospitalName }}（{{ items.address }}）</p>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </li>-->
<!--                </template>-->

<!--                <template v-if="item.productType == 0">-->
<!--                  <li>-->
<!--                    <span>预约时间</span>-->
<!--                    <p>{{ item.appointments[0].appointmentDate }} {{ item.appointments[0].appointmentTime }}</p>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <span>预约地点</span>-->
<!--                    <p>{{ item.appointments[0].hospitalName }}（{{ item.appointments[0].address }}）</p>-->
<!--                  </li>-->
<!--                </template>-->
              </ul>
            </template>
            <div class="button">
              <mu-button @click="pay_link(item)" small v-if="item.status == 0" >立即支付</mu-button>
              <mu-button @click="del(item.orderId)" small v-if="item.status == 4" >删除订单</mu-button>
              <mu-button @click="deta_link(item.orderId)" small v-if="(item.status == 2 || item.status == 1) && item.isAppointment" >查看详情</mu-button>
              <mu-button @click="make_link(item)" small v-if="item.status == 1 && !item.isAppointment" >立即预约</mu-button>
            </div>
          </li>
        </mu-load-more>
      </ul>
    </template>

    <template v-else>
      <NoList>
        <template #text>
          <p>暂无订单</p>
        </template>
      </NoList>
    </template>
<!--    <van-popup class="success_popup" v-model="show" :close-on-click-overlay="true"></van-popup>-->


  </div>
</template>

<script>
export default {
  name: "OrderList",
  data() {
    return{
      order_json: {
        pageNum: 1,
        pageSize: 10,
        // status: this.$route.query.active,
        status: "",
      },
      list: [],
      // 底部加载
      loadall: false,
      loading: true,
      show: false
    }
  },
  watch:{
    '$store.state.wxapy'(newValue) {
      let pay = newValue;
      if(pay == 0) {
        this.show= true;
        this.$store.commit("setWxapy",null);
      }else if(pay == 1) {
        this.$store.commit("setWxapy",null);
        this.list= [];
        this.order_json.pageNum= 1;
        this.get_list(this.order_json);
      }else if(pay == 2) {
        this.$store.commit("setWxapy",null);
        this.list= [];
        this.order_json.pageNum= 1;
        this.get_list(this.order_json);
      }else {
        this.$store.commit("setWxapy",null);
      }
    },
    show: {
      handler(newValue) {
        // alert(newValue)
        if(newValue) {
          // alert(this.order_json.pageNum);
          this.list= [];
          this.order_json.pageNum= 1;
          this.get_list(this.order_json);
        }
      }
    }
  },
  created() {
    // this.$isIos();

    this.$store.dispatch("setOrderState");
    this.get_list(this.order_json);


  },
  mounted() {

  },
  methods: {
    load() {
      console.log("load");
      this.loading= true;
      this.order_json.pageNum= this.order_json.pageNum + 1;
      console.log(this.order_json)
      this.get_list(this.order_json);
    },
    get_list(y) {
      this.$get("order/page",y)
        .then(res=> {
          if(res) {
            console.log(res);
            this.show= false;
            this.loadall= !res.data.hasNextPage;
            this.loading= false;

            res.data.list.forEach((item) => {
              this.list.push(item);
            })

          }
        })
    },
    tabChange(e) {
      this.list= [];
      this.order_json.status= e;
      this.get_list(this.order_json);
    },
    // 删除订单
    del(y) {
      this.$dialog.confirm({
        message: "是否删除此订单",
      })
          .then(() => {
            this.$del('order',y,true)
                .then(res => {
                  if(res) {
                    this.list= [];
                    this.order_json.pageNum = 1;
                    this.get_list(this.order_json);
                  }
                })
          })
          .catch(() => {
            // on cancel
          });
    },
    link_orderDeta(e) {
      this.$router.push({
        path: "/OrderDeta",
        query: {
          id: e
        }
      })
    },
    pay_link(e) {
      // TODO 调起微信支付
      console.log(e);

      let obj= {};
      obj["orderNo"]= e.orderNo;
      obj["prepayId"]= e.prepayId;

      obj["productId"]= e.productId;

      this.$post("order/pay",obj)
        .then(res => {
          if(res) {
            console.log(res);

            this.$wxPay(res.data);

          }
        })

      // this.$router.push({
      //   path: "/MakeSetMeal",
      //   query: {
      //     id: e.productId,
      //     price: e.productPrice,
      //     name: e.productName,
      //     isMake: true,
      //     orderNo: e.orderNo,
      //     prepayId: e.prepayId
      //   }
      // })
    },
    deta_link(e) {
      this.$router.push({
        path: "/OrderDeta",
        query: {
          id: e
        }
      })
    },
    make_link(e) {
      console.log(e)
      this.$router.push({
        path: "/MakeSetMeal",
        query: {
          id: e.productId,
          // price: e.productPrice,
          price: 0,
          name: e.productName,
          isMake: false,
          orderNo: e.orderNo,
          prepayId: e.prepayId,
          isMakeOrder: true
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
  @import "../../../style/My/Order/OrderList";
</style>
